// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-guide {
  padding: 20px;
  color: #0b2d71;
  font-family: "GothamBook";
  justify-content: flex-start;
}
.user-guide h4 {
  align-self: flex-start;
}
.user-guide .user-guide-item {
  margin-bottom: 8px;
  width: 100%;
}
.user-guide .user-guide-item a {
  box-sizing: border-box;
  color: #0066b2;
  cursor: pointer;
  display: inline-block;
  font-family: "GothamBook";
  font-size: 14px;
  font-style: normal;
  height: 21px;
  line-height: 21px;
  outline: none;
  text-decoration: none;
  -webkit-text-size-adjust: 100%;
     -moz-text-size-adjust: 100%;
          text-size-adjust: 100%;
  width: auto;
  -webkit-tap-highlight-color: transparent;
}
.user-guide .user-guide-item a:hover {
  text-decoration: underline;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
